// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';

class AddSubscriptionPayPerGame extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      customer_search_list: [],
      sub_details: {
        mobile_no: '',
        name: '',
        venue: '',
        date: moment(),
        start_date: moment(),
        end_date: moment().add(1, 'month'),
        start_time: '',
        end_time: '',
        amount: 0,
        id: '',
        session:'',
        display_name:'',
        payment_mode:'',
        coupon:'',
        game_type:''
      },
      dialog_open_cust:false,
      cart:{},
      venues: [],
      game_types: [],
      sessions: [],
      payment_modes: [],
      data_uploaded: false,
      data_error: false,
      search: false,
      post_cart_subscriptions: [],
      success_cart:{},
      selected_date:moment(),
      f_session_list:[],
      amount:0,
      value_set:false,
      // // TODO: remove after testing
      // success_cart:{"id":"ccfc2aa2-4567-4165-a3d7-ccfdb2190251","extra_details":"","amount":2950.0,"state":"completed","items":[{"id":"88c38111-5e97-4810-a617-d47f3d54e7eb","extra_details":null,"object":{"subscription_id":"44b4a5d7-f91d-4226-83d6-207f2b4c57fb","homebatch_set":false,"type":"Package","name":"Football Improve - 8 Sessions Monthly","image":"game/footbal_adults.png"},"invoice_items":[{"amount":"2,500","description":"Football Improve - 8 Sessions Monthly","amount_type":"item_price"},{"amount":"450","description":"GST","amount_type":"tax"}]}],"summary":[{"value":"2,500","label":"Item total"},{"value":"450","label":"GST"},{"value":"2,950","label":"Order total"}],"coupon":{}},
      // homebatches: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleVenueChange = this.handleVenueChange.bind(this);
    this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
  }


  componentDidMount() {
    this.getFixtureList();
    // // TODO: remove after testing
    // this.setPostSubscriptions();
    
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({ venues: data.venues, game_types: data.venues[0].game_types, payment_modes:data.payment_modes});
           // alert("fix");
           this.getPackageList();
       }).catch(error => error);
  }

  getPackageList() {
      let date = moment(this.state.selected_date).format("YYYY-MM-DD");
      let venue = this.state.sub_details.venue;
      let game_type = this.state.sub_details.game_type;
      if(!venue){venue=this.state.venues[0].id}
      if(!game_type){game_type=this.state.game_types[0].pk}
      var q_params = new URLSearchParams();
      q_params.append("venue_id", venue);
      q_params.append("game_type", game_type);
      q_params.append("date", date);
      // console.log(q_params);
     const url = `${getLocationOrigin()}/eagleeye/get_sessions_for_pay_per_game/?${q_params.toString()}`;
     const options = {...defaultOptions};
     // console.log(options);
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ sessions: data.result}))
       .catch(error => console.log(error));
  }

  getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'search': mobile_no
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_search_list: data.results, search: true}))
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  handleVenueChange(event){
    const name = event.target.name
    const value = event.target.value
    const data = this.state.venues.find(each=> each.id == value)
    var new_value =  Object.assign({}, this.state.sub_details);
    new_value[name] = value
    new_value['game_type'] = data.game_types[0].pk
    this.setState({game_types:data.game_types, sub_details:new_value},()=>this.getPackageList())
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.sub_details);
    if (name=="display_name"){
        var temp_no = event.target.value.split(":");
        if (temp_no.length == 2){
             temp_no = temp_no.pop();
            if(temp_no.length != 10){
                new_selected_one[name] = temp_no;
                new_selected_one["mobile_no"] = "";
                new_selected_one["name"] = "";
                new_selected_one["id"] = "";
                this.setState({value_set:false})
            }
            else{
                new_selected_one[name] = event.target.value
            }
        }
        else{
            new_selected_one[name] = event.target.value
        }
    }
    else{
        new_selected_one[name] = event.target.value
    }
    this.setState({sub_details: new_selected_one}, () => {
        if (name=="venue" || name=="game_type"){
            var new_selected_one =  Object.assign({}, this.state.sub_details);
            new_selected_one["session"] = "";
            this.setState({sub_details: new_selected_one}, ()=>this.getPackageList());
        }
    });
    console.log('check state',this.state)
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postAddSubscription(this.state.sub_details, this.state.cart, this.props);
    console.log('post');
    console.log(this.state);
  }

  handleCustomerSubmit(){
    console.log('post');
      
    const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'customer_name': this.state.sub_details.name,
                        'customer_mobile': this.state.sub_details.mobile_no,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
      })
      .then(data => {
        if(data.success){
          var cust = Object.assign([], this.state.sub_details);
          cust.push({'id': data.customer.id, 'name': data.customer.name, 'mobile_no':data.customer.mobile_no});
          this.setState({customer_search_list: cust});
          alert(data.message);
          this.handleClose();
        } else {
          alert(data.message);
        }
       });
    }

  handleClose = () => {
    this.setState({dialog_open_cust:false})
  }

  handleOpen = () => {
    this.setState({dialog_open_cust:true});
  };

  searchCustomer() {
    {this.state.sub_details.display_name?this.getSearchList(this.state.sub_details.display_name):
      alert('Search cannot be blank')}
  }

  setSearch(name, id, mobile){
    var new_selected_one =  Object.assign({}, this.state.sub_details);
    new_selected_one['mobile_no'] = mobile;
    new_selected_one['name'] = name;
    new_selected_one['id'] = id;
    new_selected_one['display_name'] = `${name}:${mobile}`;
    this.setState({sub_details: new_selected_one, search: false,value_set:true});
  }

 
  handleDate(date, event){
    this.setState({selected_date:date}, ()=>this.getPackageList());
  }


  
  showSession(data){
    if(!data.venue){data.venue=this.state.venues[0].id}
    if(!data.game_type){data.game_type=this.state.game_types[0].pk}
    // if(!data.payment_mode){data.payment_mode=Object.keys(this.state.payment_modes)[0]}
    if (!data.session){
      alert("please select session");
    }
    else if (!data.id){
      alert("please select customer");
    }
    else if (data.payment_mode == ''){
      alert("please select payment mode");
    }
    else{
      var msg = `Are you sure?`;
      var result = confirm(msg);
      if(result == true){
        const url = `${getLocationOrigin()}/eagleeye/crete_subscription_for_pay_per_game/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
            'session_id': data.session,
            'customer_id': data.id,
            'payment_mode': data.payment_mode
        });
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            alert(data.message)

        })
        .catch(error => {
            console.log(error);
            alert(error.message);
        });
      }
    }
  }
  

  render() {
    console.log('details',this.state.sub_details)

    const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];


    return(
      <div style={{...styles.container}}>
      {/* <div className="container" style={{...styles.container, ...styles.work_in_progress}}>
          <div style={{
              position: "absolute",
              paddingTop: "25%",
              height: "100%",
              zIndex: "100",
              width: "100%",
              textAlign: "center",
              background: "#0f2c3ca3",
              color: "white",
              fontSize: "200%",
              fontWeight: "bold",
          }}>
              Work in Progress
          </div> */}
        
            <div className="row col-md-8 table-bordered" style={styles.table}>
              <div style={styles.main_header} className="col-md-12">
                <h3 style={{textAlign:'center'}}>Add Subscription Pay Per Game</h3>
              </div>
              <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                <div style={styles.items} className="col-md-10">
                  <div style={styles.item_header} className="col-md-6">
                    Customer
                  </div>
                  <div className="col-md-6 input-group" style={{width:'60%'}}>
                    <input type="text" name="display_name" className="form-control"
                    placeholder="Search for.. " value={this.state.sub_details.display_name}  onChange={this.handleChange} style={{ backgroundColor: this.state.value_set ? '#32B6A7': 'white'}}/>
                  <span className="input-group-btn">
                    <button className="btn btn-default glyphicon glyphicon-search"
                    type="button" onClick={this.searchCustomer}></button>
                  </span>
                  </div>
                </div>
                {this.state.search?
                        <div className="col-md-12 btn-group">
                            {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                        style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                        :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                <div className="alert alert-danger">Search customer not found</div>
                <div>
                    <RaisedButton
                      onClick={this.handleOpen}
                      label="Add"
                      style={{float:'right'}}
                      secondary={true}
                    />
                    <Dialog
                      actions={actions}
                      modal={false}
                      open={this.state.dialog_open_cust}
                      onRequestClose={this.handleClose}
                    >
                      <div>
                          <div style={styles.main_header} className="col-md-12">
                              <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                            </div>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Name
                                  </div>
                                  <input type="text" style={styles.input} name="name" className="required"
                                    value={this.state.value} onChange={this.handleChange}/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                  <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '11%',}} className="col-md-6">
                                    Mobile No
                                  </div>
                                <input type="number" style={styles.input} name="mobile_no" className="required"
                                  value={this.state.sub_details.mobile_no} onChange={this.handleChange}/>
                              </div>
                            </div>
                          </Dialog>
                        
                        </div>
                        </div>
                      }</div>:''}

               
                <div style={styles.items} className="col-md-10">
                  <div style={styles.item_header} className="col-md-6">
                    Venue
                  </div>
                  <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                    onChange={this.handleVenueChange}>
                    {
                      this.state.venues.map((x, index) => (
                      <option key={x.id} value={x.id}>{x.name}</option>
                      ))
                    }
                  </select>
                </div>

                <div style={styles.items} className="col-md-10">
                  <div style={styles.item_header} className="col-md-6">
                    Game Type
                  </div>
                  <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.sub_details.game_type}
                    onChange={this.handleChange}>
                    {
                      this.state.game_types.map((x, index) => (
                      <option key={x.pk} value={x.pk}>{`${x.game} ${x.name}`}</option>
                      ))
                    }
                  </select>
                </div>
                <div style={styles.items} className="col-md-10">
                  <div style={styles.item_header} className="col-md-6">
                    Date
                  </div>
                  <div style={{width:'100%',marginLeft:'11%'}}>
                  <DatePicker name="date" dateFormat={'DD/MM/YYYY'} selected={moment(this.state.selected_date)} onChange={(date, e) => this.handleDate(date,e)}/>
                  </div>
                </div>
                <div style={styles.items} className="col-md-10">
                  <div style={styles.item_header} className="col-md-6">
                    Session
                  </div>
                  <select name="session" className="col-md-6" style={styles.item_body} value={this.state.value}
                    onChange={this.handleChange}>
                    <option key={1} value={""}>{`-------`}</option>
                    {
                      this.state.sessions.map((x, index) => (
                      <option key={x.id} value={x.id}>{`${x.name} - Rs.${x.mrp}`}</option>
                      ))
                    }
                  </select>
                </div>

                <div style={styles.items} className="col-md-10">
                  <div style={styles.item_header} className="col-md-6">
                    Payment Mode
                  </div>
                  <select name="payment_mode" className="col-md-6" style={styles.item_body} value={this.state.value}
                    onChange={this.handleChange}>
                    <option>--select--</option>
                    {
                      Object.keys(this.state.payment_modes).map((x, index) => (
                      <option key={x} value={x}>{this.state.payment_modes[x]}</option>
                      ))
                    }
                  </select>
                </div>
                
                <div className="col-md-12" style={{textAlign:'center',marginTop:'20px'}}>
                  <input type="button" className="button1" value="Add Subscription" onClick={()=>this.showSession(this.state.sub_details)}/>
                </div>
                </form>
               
                

            </div>
      </div>
    );
  }
}

export default AddSubscriptionPayPerGame;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addSubsForPayPerGame/index.js